<template>
  <div class="button-group d-flex flex-wrap">
    <template v-for="(mode, index) in modes">
      <b-button
          :key="mode.name"
          :variant="value === mode.name ? 'primary' : 'transparent'"
          :class="buttonClass(index)"
          style="border-radius: 4px"
          @click="onClick(mode.name)"
      >
        {{ mode.label }}
      </b-button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'purchase-plan-relation-tabs',
  props: {
    value: { type: String, default: 'purchase_orders' },
    modes: {
      type: Array,
      default() {
        return [
          { name: 'purchase_orders', label: this.lodash.startCase(this.$t('purchase_orders.plural')) },
          { name: 'trips', label: this.lodash.startCase(this.$t('trips.plural')) },
        ];
      }
    }
  },
  methods: {
    buttonClass(index) {
      return {
        'ms-1': index > 0,
        'me-1': index < this.modes.length - 1,
      };
    },
    onClick(mode) {
      this.$emit('input', mode);
      this.$emit('click', mode);
    }
  }
};
</script>

<style scoped>
::v-deep {
  .btn {
    padding: 8px 16px;
    font: 600 14px/16px Lato, sans-serif;
    border-radius: 8px !important;
  }
}
.button-group {
  background-color: #F2F4F7;
  border-radius: 8px;
  padding: 4px;
  width: fit-content;
}
</style>
